import React, { useState } from "react";
import { toast } from "react-toastify";
import { Input, Popup } from "semantic-ui-react";
import { validateTelegramToken, storeTelegramToken } from "../../../../../actions/authAction";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import "../AppstoreModal/AppstoreCredentialModal.scss";
import Loader from "semantic-ui-react/dist/es/elements/Loader/Loader";
import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";

const TelegramCredentialModal = ({ hideModal, fetchToken }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [botToken, setbotToken] = useState("");
    const [displayName, setdisplayName] = useState("");

    const handleSave = async () => {
        if (botToken.trim() == "") {
            toast.error("Please enter your Bot Token");
            return;
        }
        if (displayName.trim() == "") {
            toast.error("Please enter your Display Name");
            return;
        }
        setIsLoading(true);

        const obj = {
            bot_token: botToken.trim(),
            display_name: displayName.trim(),
        };

        const data = await validateTelegramToken(obj);
        console.log("validatePlaystoreToken", data);
        if (data?.status === "success") {
            const params = {
                //scopes: ["appstoreconnect-v1"],
                access_token: botToken.trim(),
                token_source: "app",
                app_name: "unknown",
                platform_id: "a6b7213e-9628-11ec-a6e7-021beeb7e652",
                token_name: displayName.trim(),
            };

            await storeTelegramToken(params);
        } else {
            toast.error("Invalid credentials");
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        fetchToken();

        hideModal();
    };

    return (
        <Modal className={`canned-block`} show onClose={hideModal}>
            <Modal.Header className="appstore__heading">
                Telegram
                <Popup
                    className="infoPopup skiptranslate"
                    position="bottom center"
                    size="mini"
                    content="Telegram integration works for groups. Each group must be integrated into a bot that is integrated to the Radarr platform."
                    trigger={
                        <div className="info-icon" data-html2canvas-ignore="true">
                            <InfoIcon className="info__icon" />
                        </div>
                    }
                    // open
                    style={{ zIndex: "99999999" }}
                />
            </Modal.Header>
            <Modal.Content className="canned-block-container">
                <div className="category-conatiner">
                    <p>Please enter your Bot Token *</p>
                </div>
                <div className="canned-block-title-input ">
                    <Input className="field" placeholder="Bot Token" type="text" onChange={(e) => setbotToken(e.target.value)} value={botToken} required />
                </div>
                <div className="category-conatiner">
                    <p>Please enter your Display Name *</p>
                </div>
                <div className="canned-block-title-input ">
                    <Input
                        value={displayName}
                        type="text"
                        className="field"
                        placeholder="Display Name"
                        onChange={(e) => setdisplayName(e.target.value)}
                        required
                    />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton normal onClick={hideModal}>
                    Cancel
                </Modal.ActionButton>
                <Modal.ActionButton className="appstore__action__button" disabled={isLoading} filled onClick={handleSave}>
                    {isLoading ? <Loader active /> : null}
                    Save
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default TelegramCredentialModal;
